// extracted by css-extract-rspack-plugin
export default {"user-avatar":"SCj15S","userAvatar":"SCj15S","pixelated":"J0EFZc"};